import { render, staticRenderFns } from "./MerchantPaymentConfigManage.vue?vue&type=template&id=e5ef53d2&scoped=true"
import script from "./MerchantPaymentConfigManage.vue?vue&type=script&lang=js"
export * from "./MerchantPaymentConfigManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ef53d2",
  null
  
)

export default component.exports